import styled from '@emotion/styled';
import React from 'react';
import Link from 'next/link';
import Colors from '../styles/Colors';
import Text, { TextTypesEnum } from '../elements/Text';
import BoxShadows from '../styles/BoxShadows';

const BannerWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    background-color: white;
    padding: 14px 0px;
    box-shadow: ${BoxShadows.Hard};
`;

const BannerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  max-width: 600px;
`;

const BannerButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  background-Color: ${Colors.Green200};
  padding: 8px 12px;
  border-radius: 4px;
`;

const OfficeSpaceDashboardNoticeBanner: React.FC = () => (
  <BannerWrapper>
    <BannerTextWrapper>
      <Text
        type={TextTypesEnum.Bold16}
        align="left"
      >
        IMPORTANT
      </Text>
      <Text
        type={TextTypesEnum.Regular16}
        align="left"
      >
        Effective 7/1/2023 the Biproxi marketplace will be fully transitioned over to OfficeSpace.com.
        All listing information, documents, etc. will be removed and no longer accessible after this date.
      </Text>
    </BannerTextWrapper>
    <Link href="https://www.officespace.com/pages/biproxi-marketplace" target="_blank">
      <BannerButtonWrapper>
        <Text
          type={TextTypesEnum.Bold16}
          color={Colors.Blue600}
        >
          Learn more about the transition to OfficeSpace.com
        </Text>
      </BannerButtonWrapper>
    </Link>
  </BannerWrapper>
);

export default OfficeSpaceDashboardNoticeBanner;
